import gql from 'graphql-tag'

export const GET_EVENTS = gql`
  query coordinatorEvents {
    coordinator {
      event {
        list {
          id
          name
          dates {
            id
            date
          }
          hosts {
            id
            firstName
            lastName
          }
          state
          duration
          datePublished
          state
        }
      }
    }
  }
`

export const GET_EVENT_DETAILS = gql`
  query coordinatorEventById($eventId: String!) {
    coordinator {
      event {
        eventSignUps(eventId: $eventId) {
          id
          myPathCurrentPosition {
            id
            currentPosition {
              step {
                index
              }
              level {
                index
              }
            }
          }
          user {
            id
            firstName
            lastName
            email
          }
          audience {
            id
            name
          }
          invitation {
            id
            name
            rsvp
          }
          userActiveLab {
            id
            name
          }
          signed
          attended
        }
        byId(id: $eventId) {
          maxSignUps
          id
          state
          userAcceptedCount
          userSignUpsCount
          userAttendedCount
        }
      }
    }
  }
`
